<template>
  <li v-if="information.length != 0" class="information-box">
    <div class="title">
      <h1>资讯</h1>
	  <el-link
	  type="success "
	  :underline="false"
	  :href="tgurl"
	  target="_blank">
	  我要投稿></el-link>
      <el-link
        type="primary"
        :underline="false"
        :href="'/Index/wjs_search_res.html?kw=' + $route.query.name"
        target="_blank"
      >
        更多></el-link
      >
    </div>

    <div class="con information">
      <a
        v-for="(i, index) in information"
        :key="index"
        :href="'/detail--' + i.id + '.html'"
        target="_blank"
      >
        <p>{{ i.title }}</p>
      </a>
    </div>
  </li>
</template>

<script>
export default {
  name: "information",
  // props:{
  //     Informationdata:{
  //         type:Array
  //     },
  //     getzx:{
  //         type:Function
  //     }
  // },
  data() {
    return {
      information: [],
	  tgurl: 'http://www.100ec.cn/about/submit.html',
    };
  },
//   methods: {
//     getzx() {
//       axios.get("/searchjson.html?p=1&n=10&terms=" + this.$route.query.name)
//         .then((res) => {
//           console.log(111);
//           console.log(res);
//           this.Informationdata = res.data.list;
//         });
//     },
//   },
  // created(){
  //     this.getzx()
  // }
 
  mounted() {
      axios.get('/searchjson.html?p=1&n=10&terms=' + this.$route.query.name)
      .then((res) => {
          this.information = res.data.list
      })
  },
};
</script>

<style scoped>
.information {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.information a {
  flex: 0 0 46%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  overflow: hidden;
}
.information p {
  flex: 0 0 100%;
  font-size: 18px;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: all 0.3s ease;
}
.information a:hover {
  background: #eee;
}
.information a:hover p {
  color: #409eff;
}
.information span {
  color: #ccc;
  line-height: 26px;
}

@media (max-width: 868px) {
  .information,
  .information a {
    display: inherit;
  }
  .information p {
    font-size: 16px;
  }
}
</style>